import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, map, filter } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

export interface ApplicationType {
  id: number;
  active_version: number;
  name: string;
  active: boolean;
}

export interface SignupValues {
  createAccountFirstName: string;
  createAccountLastName: string;
  createAccountEmailAddress: string;
  createAccountPasswordText: string;
  createAccountApplicationType: string;
}

export interface StartApplicationValues {
  startApplicationFirstName: string;
  startApplicationLastName: string;
  startApplicationEmailAddress: string;
  startApplicationPasswordText: string;
  startApplicationApplicationType: string;
}

@Injectable({
  providedIn: 'root'
})
export class WelcomeService {
  public applicationTypesSubject: BehaviorSubject<ApplicationType[]> = new BehaviorSubject(null);
  public applicationTypes: Observable<ApplicationType[]> = this.applicationTypesSubject.pipe(
    filter((as) => as !== null)
  );

  constructor(private http: HttpClient) {}

  getApplicationTypes() {
    this.http
      .get(environment.endpoints.applicationTypeApi)
      .pipe(
        map((response: Response) => {
          return <ApplicationType[]>response['results'];
        })
      )
      .subscribe((applicationTypes: ApplicationType[]) => this.applicationTypesSubject.next(applicationTypes));
  }

  signup(signupValues: SignupValues): Observable<Object> {
    const signupObj = {
      first_name: signupValues.createAccountFirstName,
      last_name: signupValues.createAccountLastName,
      email: signupValues.createAccountEmailAddress,
      password: signupValues.createAccountPasswordText,
      appType: signupValues.createAccountApplicationType
    };

    return this.http.post(environment.endpoints.userApi, signupObj);
  }

  start(signupValues: StartApplicationValues): Observable<any> {
    const signupObj = {
      first_name: signupValues.startApplicationFirstName,
      last_name: signupValues.startApplicationLastName,
      email: signupValues.startApplicationEmailAddress,
      password: signupValues.startApplicationPasswordText,
      appType: signupValues.startApplicationApplicationType
    };
    return this.http.post(environment.endpoints.userApi, signupObj);
  }

  checkValidationKey(validationKey: string): Observable<any> {
    return this.http.get(`${environment.endpoints.checkValidationKey}${validationKey}`);
  }
}
